import Text from "../../../../styleguide/Text";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";

function TableCustomHeader() {
  return (
    <div className="mb-3 flex items-center justify-between gap-4">
      <Text
        variant="h3"
        component="h3"
        className="mb-4 font-semibold text-slate-900"
        gutterBottom>
        Flota cu nodurile corespunzatoare
      </Text>

      <ActionMenu
        items={[
          {
            id: "assign-car",
            label: "Adauga masina noua",
            icon: "ADD",
            tooltip: "Deschide formularul pentru asocierea unei masini la nod.",
            navigate: "create",
          },
        ]}
        ariaLabel="Actiuni pentru flota cu noduri"
      />
    </div>
  );
}

export default TableCustomHeader;
